var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.forwarderStore)?_c('lora-forwarder-packets-log',{attrs:{"load-expanded":true,"forwarder-store":_vm.forwarderStore}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }